<template>
  <order-list :role="USER_ROLES.CLIENT_AGENT" />
</template>
<script>
import OrderList from "@/components/order-list/OrderList.vue";
import { USER_ROLES } from "@/consts";
import normalPage from "@/mixins/normal-page";
export default {
  mixins: [normalPage],
  components: {
    OrderList,
  },
  data() {
    return { USER_ROLES };
  },
};
</script>
<style lang="less"></style>
